module.exports = __webpack_public_path__ + "static/media/gallery.1c9e3425.svg";